module.exports = __webpack_public_path__ + "static/media/foto-con-estrellas.92e9011a.png";